export default __webpack_public_path__ + "static/media/modernhouse.06bded6d.jpg";